import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';
import { Paragraph1 } from 'inpock-ui-react';

import IconMenu from '@/assets/icons/icon-menu.svg';
import IconCart from '@/assets/icons/icon-cart.svg';

export const MarketHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const MarketNotice = styled.div`
  background: ${colors.gray800};
  height: 34px;
  position: relative;
  z-index: 3;

  .translucent-layer {
    position: absolute;
    width: 100%;
    height: 34px;
    opacity: 0;
  }

  .marquee-container {
    padding: 7px 15px;
  }

  &:hover {
    .translucent-layer {
      background: white;
      opacity: 0.15;
    }
  }
`;

export const MarketTitle = styled.div`
  padding: 0 12px;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.white};
  transition: transform 0.3s ease-in-out;
  border-bottom: 1px solid var(--color-ui-grayscale-gray-100);

  &.hidden {
    transform: translateY(-100%);
  }
`;

export const MarketLogoText = styled(Paragraph1)`
  font-size: 18px;
`;

export const MarketLogoImage = styled.img`
  height: 24px;
  object-fit: contain;
`;

export const BtnCartContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

export const BtnCart = styled.div`
  padding: 8px;
  cursor: pointer;
  background-image: url(${IconCart});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 17px;
  height: 22px;
`;

export const CartCount = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${colors.orange800};
  right: -8px;
  top: -4px;
  display: flex;
  justify-content: center;
`;

export const BtnMenu = styled.div`
  padding: 8px;
  cursor: pointer;
  background-image: url(${IconMenu});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 24px;
  height: 24px;
`;

export const ImageSection = styled.section`
  padding: 0;
  position: relative;
  z-index: 1;
`;

export const SwiperPagination = styled.div`
  width: auto;
  margin-left: 12px;
  margin-bottom: 12px;
  border-radius: 40px;
  padding: 2px 10px;
  background: rgba(0, 0, 0, 0.5);
  color: white;

  .swiper-pagination-current,
  .swiper-pagination-total {
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
`;

export const MarketImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const SkeletonLogo = styled.div`
  padding: 12px;
`;
